import { AutomationVariableType, AutomationVariableValue, FieldType } from '.';
import { IEntityAttribute } from './Attribute';

export interface IConditionOption {
  variableType: AutomationVariableType;
  id: IEntityAttribute;
  displayName: String,
  attributeType: FieldType,
  group: ConditionOptionGroup,
  choices?: IConditionOptionChoice[],
  defaultValue?: AutomationVariableValue;
}

export interface IConditionOptionChoice {
  value: AutomationVariableValue,
  displayName: String,
  image?: string
}

export enum ConditionOptionGroup {
  DEFAULT_MEMBER_DATA = 'DEFAULT_MEMBER_DATA',
  CUSTOM_MEMBER_DATA = 'CUSTOM_MEMBER_DATA',
  ALLOY = 'ALLOY',
  API_EXPLORER_APPLICATION = 'API_EXPLORER_APPLICATION',
  AUTOMATION = 'AUTOMATION',
  BRIEFS = 'BRIEFS',
  CONTENT = 'CONTENT',
  CONTRACTS = 'CONTRACTS',
  CREATE_ARCHIVES = 'CREATE_ARCHIVES',
  CREATE_GIFT_ORDER = 'CREATE_GIFT_ORDER',
  CREATOR_SEARCH = 'CREATOR_SEARCH',
  GMAIL = 'GMAIL',
  IGDM = 'IGDM',
  INFO_UPDATE = 'INFO_UPDATE',
  OUTLOOK = 'OUTLOOK',
  PAYMENT = 'PAYMENT',
  REMINDER = 'REMINDER',
  SALES_TRACKING = 'SALES_TRACKING',
  SHOPIFY = 'SHOPIFY',
  SOCIAL_ENRICHMENT = 'SOCIAL_ENRICHMENT',
  SOCIAL_POST = 'SOCIAL_POST',
  TRAY_IO = 'TRAY_IO',
  TWILIO = 'TWILIO',
  WOOCOMMERCE = 'WOOCOMMERCE',
  ZAPIER = 'ZAPIER',
  UNKNOWN = 'UNKNOWN',
  PRODUCT_FULFILLMENT = 'PRODUCT_FULFILLMENT',
  // PFA = 'PRODUCT_FULFILLMENT',
}

export const MAP_APP_NAME_TO_GROUP = {
  'Alloy': ConditionOptionGroup.ALLOY,
  'API Explorer Application': ConditionOptionGroup.API_EXPLORER_APPLICATION,
  'Automation': ConditionOptionGroup.AUTOMATION,
  'Briefs': ConditionOptionGroup.BRIEFS,
  'Content': ConditionOptionGroup.CONTENT,
  'Contracts': ConditionOptionGroup.CONTRACTS,
  'Create Archives': ConditionOptionGroup.CREATE_ARCHIVES,
  'Create Gift Order': ConditionOptionGroup.CREATE_GIFT_ORDER,
  'Creator Search': ConditionOptionGroup.CREATOR_SEARCH,
  'Gmail': ConditionOptionGroup.GMAIL,
  'IGDM': ConditionOptionGroup.IGDM,
  'Info Update': ConditionOptionGroup.INFO_UPDATE,
  'Outlook': ConditionOptionGroup.OUTLOOK,
  'Payment': ConditionOptionGroup.PAYMENT,
  'Reminder': ConditionOptionGroup.REMINDER,
  'Sales Tracking': ConditionOptionGroup.SALES_TRACKING,
  'Shopify': ConditionOptionGroup.SHOPIFY,
  'Social Enrichment': ConditionOptionGroup.SOCIAL_ENRICHMENT,
  'Social Post': ConditionOptionGroup.SOCIAL_POST,
  'Terms': ConditionOptionGroup.BRIEFS,
  'Tray.io': ConditionOptionGroup.TRAY_IO,
  'Twilio': ConditionOptionGroup.TWILIO,
  'WooCommerce': ConditionOptionGroup.WOOCOMMERCE,
  'Zapier': ConditionOptionGroup.ZAPIER,
  'Product Fulfillment': ConditionOptionGroup.PRODUCT_FULFILLMENT,
  'PFA': ConditionOptionGroup.PRODUCT_FULFILLMENT,
};
